import Popover2 from './Popover2';
export * from './Popover2';
export default Popover2